import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 3000 }, active: Boolean }

  connect() {
    if (!this.activeValue) return

    this.timer = setTimeout(() => this.refresh(), this.intervalValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  refresh() {
    const frame = this.element.closest("turbo-frame")
    if (!frame) return

    if (frame.src) {
      frame.reload()
    } else {
      frame.src = this.urlValue
    }
  }
}
